import { Injectable, Inject, Optional } from "@angular/core";
import { DEFAULT_ENVIRONMENT } from "./default-environment";
import { ENVIRONMENT_CONFIG } from "./environment.token";
import { WebRtcCommunicationEnvironmentConfig } from "./environment-config";

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  public mergedConfig: any;

  constructor(@Optional() @Inject(ENVIRONMENT_CONFIG) externalConfig: Partial<WebRtcCommunicationEnvironmentConfig>) {
    // this.mergedConfig = { ...DEFAULT_ENVIRONMENT, ...externalConfig };
    // // Se vuoi fare merge profondo per oggetti annidati (es. rtcConfig), fai così:
    // this.mergedConfig.rtcConfig = {
    //   ...DEFAULT_ENVIRONMENT.rtcConfig,
    //   ...externalConfig.rtcConfig
    // };
    this.mergedConfig = this.deepMerge(DEFAULT_ENVIRONMENT, externalConfig);
  }

  deepMerge(target: any, source: Partial<any>): any {
    const output = { ...target };
    for (const key in source) {
      if (source[key] !== undefined) {
        if (Array.isArray(source[key])) {
          output[key] = [...source[key]];
        } else if (source[key] instanceof Object && key in target && 
                 !Array.isArray(target[key])) {
          output[key] = this.deepMerge(target[key], source[key]);
        } else {
          output[key] = source[key];
        }
      }
    }
    return output;
  }

  get config(): WebRtcCommunicationEnvironmentConfig {
    return this.mergedConfig;
  }

  get(key: string) {
    return this.mergedConfig[key];
  }

  set(key: string, value: any) {
    this.mergedConfig[key] = value;
  }

}